import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../context';

import { FulfillmentServiceDropdown } from './index';

const getFulfillmentServices = (state, shipFromId) => {
  const filteredFulfillmentServices =
    Global.selectSellerFulfillmentServicesByShipFromId(state, {
      selectedShipFromId: shipFromId,
    }) || [];

  return filteredFulfillmentServices.map(({ fulfillmentServiceId, name }) => ({
    name,
    id: fulfillmentServiceId,
  }));
};

export const FulfillmentServiceContainer = ({ id, dropdownMenuType }) => {
  const { shipFromId, fulfillmentServiceId, onFulfillmentServiceChange } = useFulfillmentPlannerContext();
  const fulfillmentServices = useSelector((state) => {
    return getFulfillmentServices(state, shipFromId);
  });

  return (
    <FulfillmentServiceDropdown
      dropdownMenuType={dropdownMenuType}
      fulfillmentServices={fulfillmentServices}
      id={id}
      onChange={onFulfillmentServiceChange}
      selectedFulfillmentServiceId={fulfillmentServiceId}
    />
  );
};

FulfillmentServiceContainer.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
};
